import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-valid-voter-changes',
  templateUrl: './valid-voter-changes.component.html',
  styleUrls: ['./valid-voter-changes.component.less', '../../shared/common.less']
})
export class ValidVoterChangesComponent implements OnInit {
  @Output() private close: EventEmitter<void> = new EventEmitter();

  constructor() { }

  closeValidationPopup() {
    this.close.emit();
  }

  ngOnInit(): void {
  }

}
